
import { Link } from 'react-router-dom';

export default function DealershipHero() {
  const scrollToProducts = () => {
    const element = document.getElementById('products');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative py-20 bg-gradient-to-br from-emerald-50 to-teal-50 overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/584f12e68a15a9aaa1591969b4d624f8.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-900/80 to-teal-900/60"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              Dealership Opportunities
            </h1>
            <p className="text-xl mb-8 text-emerald-100">
              Partner with us to sell premium glamping products and retreat developments. 
              No franchise fees - just a one-time investment for complete business support.
            </p>
            
            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
                <div className="text-2xl font-bold text-white">$0</div>
                <div className="text-emerald-200">Franchise Fees</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
                <div className="text-2xl font-bold text-white">100%</div>
                <div className="text-emerald-200">Business Support</div>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:256-268-7146"
                className="bg-white text-emerald-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap"
              >
                Schedule Consultation
              </a>
              <Link
                to="/catalog"
                className="bg-white text-emerald-600 px-8 py-4 rounded-lg font-semibold border-2 border-emerald-600 hover:bg-emerald-50 transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                Download Catalog
              </Link>
            </div>
            
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <div className="bg-white rounded-lg p-6 shadow-lg">
                <div className="w-12 h-12 bg-emerald-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-home-4-line text-white text-xl"></i>
                </div>
                <h3 className="font-bold text-gray-900 mb-2">Premium Products</h3>
                <p className="text-gray-600 text-sm">Geo domes, tiny homes, safari tents, and solar systems</p>
              </div>
              <div className="bg-white rounded-lg p-6 shadow-lg">
                <div className="w-12 h-12 bg-emerald-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-marketing-line text-white text-xl"></i>
                </div>
                <h3 className="font-bold text-gray-900 mb-2">Marketing Support</h3>
                <p className="text-gray-600 text-sm">Complete advertising campaigns and materials</p>
              </div>
            </div>
            <div className="space-y-4 mt-8">
              <div className="bg-white rounded-lg p-6 shadow-lg">
                <div className="w-12 h-12 bg-emerald-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-computer-line text-white text-xl"></i>
                </div>
                <h3 className="font-bold text-gray-900 mb-2">POS Systems</h3>
                <p className="text-gray-600 text-sm">Integrated booking and payment processing</p>
              </div>
              <div className="bg-white rounded-lg p-6 shadow-lg">
                <div className="w-12 h-12 bg-emerald-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-team-line text-white text-xl"></i>
                </div>
                <h3 className="font-bold text-gray-900 mb-2">Training Program</h3>
                <p className="text-gray-600 text-sm">Comprehensive business and product training</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
